import assert from 'assert'
import _ from 'lodash'

export default class InputFormatter {
  constructor ({ mask, placeholder = '*', valueRegex, valueLength }) {
    this.mask = mask
    this.placeholder = placeholder
    this.valueLength = valueLength
    this.valueRegex = valueRegex
    this.buffer = []
    this.result = ''
    this.backspace = false
  }

  initBuffer () {
    this.buffer = this.mask.split('')
    return this
  }

  getBufferLength () {
    this.initBuffer()
    return this.buffer.length
  }

  getMaskChars () {
    let maskChars = []
    _.each(this.mask.split(''), (char, index) => {
      if (char !== this.placeholder) {
        maskChars = [
          ...maskChars,
          char
        ]
      }
    })
    return maskChars
  }

  fillBuffer (value) {
    // we only care about correct value
    const matches = value.match(this.valueRegex)

    let values = []
    _.each(matches, (match) => {
      // only one char match, for instance: this.valueRegex = /([0-9])+/g
      if (match.length === 1) {
        values = [
          ...values,
          match
        ]
      } else {
        // multiple char match, for instance: this.valueRegex = /([0-9]+)/g
        values = [
          ...values,
          ...match.split('')
        ]
      }
    })
    // insert values into buffer correctly
    let valuesIndex = 0
    for (let index = 0; index < this.buffer.length; index += 1) {
      if (this.buffer[index] === this.placeholder && values[valuesIndex]) {
        this.buffer[index] = values[valuesIndex]
        valuesIndex += 1
      }
    }
    return this
  }

  renderBuffer () {
    const firstPlaceholderIndex = this.buffer.indexOf(this.placeholder)
    if (firstPlaceholderIndex === -1) {
      this.result = this.buffer.join('')
      return this
    }
    this.result = this.buffer
      .slice(0, firstPlaceholderIndex)
      .join('')
    return this
  }

  format (value = '') {
    assert(typeof value === 'string', 'value must be string')
    this
      .initBuffer() // call init buffer
      .fillBuffer(value) // fill buffer with value
      .renderBuffer() // transform buffer to result
    return this
  }
}

export const phoneFormatter = new InputFormatter({
  mask: '(***) ***-****',
  placeholder: '*',
  valueRegex: /([0-9]+)/gi
})
